import React from "react";
import Context from "../../../context/Context";

export function renderDetailsLink(item) {
  if (!item) return null;
  const portalUrl = Context.instance.getPortalUrl();
  let href = portalUrl + "/home/item.html?id=" + encodeURIComponent(item.id);
  href = Context.checkMixedContent(href);
  return (
    <a className={"i-button-clear-no-border i-font-brand-primary"} target="_blank" rel="noopener noreferrer"
      href={href}>{Context.instance.i18n.portalItemBrowser.details}</a>
  );
}
